<template>
	<div class="container-breadcrumb">
		<div class="title-breadcrumb">
			<feather class="config-icon-return" type="arrow-left" size="20" @click="goBack" />
			<h1 v-if="this.$route.params.id" class="text-breadcrumb">
				{{ route }} #{{ this.$route.params.id }}
			</h1>
			<h1 v-else class="text-breadcrumb">
				{{ route }}
			</h1>
		</div>
		<div>
			<!--   <div class="date-picker-analytics">
        <b-datepicker
          v-model="rangedate"
          position="is-bottom-left"
          :mobile-native="true"
          range
        >
          <template v-slot:trigger>
            <feather
              type="calendar"
              size="18px"
            />
          </template>
        </b-datepicker>
      </div> -->
			<feather
				v-if="currentroute === 'Usuários'"
				title="Adicionar Usuário"
				class="add-icon"
				type="user-plus"
				size="20px"
				@click="$router.push(`novo/`)"
			/>
			<feather
				v-if="isTabPessoasChecked > 0"
				class="add-icon"
				title="Remover Pessoa"
				type="user-minus"
				size="20px"
				@click="removeperson"
			/>
			<feather
				v-if="datacheckedEditPessoas"
				class="add-icon"
				type="user-plus"
				size="20px"
				title="Adicionar Pessoa"
				@click="showModal"
			/>
			<feather
				v-if="
					currentroute === 'Condição de Pagamento' ||
					currentroute === 'Tabela de Vendas' ||
					currentroute === 'Forma de Pagamento'
				"
				class="add-icon"
				:title="`Adicionar ` + currentroute"
				type="plus-square"
				size="20px"
				@click="
					currentroute !== 'Forma de Pagamento'
						? setModalCondPagamento()
						: $store.dispatch('setModalPagamento', true)
				"
			/>
			<feather
				v-if="userPermissions[0].per_criausuadm === 1 && currentroute === 'Adm Usuários'"
				class="add-icon"
				title="Adicionar Adm Usuários"
				type="plus-square"
				size="20px"
				@click="$router.push('user/new/')"
			/>
		</div>
	</div>
</template>

<script>
import jwtdecode from 'jwt-decode';
import cookie from 'vue-cookie';
import * as ecAxios from '../../../util/ecAxios';

export default {
	data() {
		const today = new Date();
		return {
			currentroute: '',
			date: new Date(),
			minDate: new Date(today.getFullYear() - 80, today.getMonth(), today.getDate()),
			maxDate: new Date(today.getFullYear() + 18, today.getMonth(), today.getDate()),
			fpagamentoData: true,
			rangedate: [],
			userPermissions: [
				{
					id: 21,
					per_altusuadm: 0,
					per_criausuadm: 0,
					status: 0,
					usuario: 'permissiontest',
				},
			],
		};
	},
	computed: {
		route() {
			if (this.currentroute === '') {
				return this.$router.currentRoute.name;
			}
			return this.currentroute;
		},
		isTabPessoasSelected() {
			return this.$store.getters.getDatabase.tabSelected;
		},
		isTabPessoasChecked() {
			let status = 0;
			if (this.$store.getters.getDatabase.checked) {
				const arr = Array.from(this.$store.getters.getDatabase.checked);
				const check = JSON.parse(JSON.stringify(arr));
				check.forEach((element) => {
					if (element.id === undefined) {
						status = 0;
					} else {
						status = 1;
					}
				});
			}
			return status;
		},
		datacheckedEditPessoas() {
			if (
				this.currentroute === 'Editar' ||
				this.currentroute === 'Usuário - Detalhes'
			) {
				return true;
			}
			return false;
		},
		dataselectedEditPessoas() {
			return this.$store.getters.getDatabase.selecionado !== undefined;
		},
		detailId() {
			return localStorage.getItem('pageDetailId');
		},
	},
	watch: {
		rangedate(e) {
			this.$store.dispatch('setGlobalPickerDate', e);
		},
		$route() {
			this.currentroute =
				(this.$router.currentRoute.meta && this.$router.currentRoute.meta.title) ||
				this.$router.currentRoute.name;
			this.$store.dispatch('setDatabase', {});
		},
	},
	created() {
		this.currentroute =
			(this.$router.currentRoute.meta && this.$router.currentRoute.meta.title) ||
			this.$router.currentRoute.name;
		this.verifyUserPermission();
	},
	methods: {
		adduser() {
			this.$store.dispatch('setAddNewUser', true);
		},
		async verifyUserPermission() {
			const userid = this.jwtDecoded().sub;
			if (userid) {
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.ADM_USUARIOS}`, {
						offset: 0,
						limit: 1,
						id: userid,
					})
					.then((response) => {
						if (response) {
							this.userPermissions = response.data.usuarios;
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
		},
		jwtDecoded() {
			let decoded = '';
			if (
				cookie.get('admtoken', {
					host: window.location.host,
				}) !== null
			) {
				const token = cookie.get('admtoken', {
					host: window.location.host,
				});
				decoded = jwtdecode(token);
			}
			return decoded;
		},
		async removeperson() {
			const check = this.$store.getters.getDatabase.checked;
			const usuario = this.$route.params.id;
			const elements = [];
			check.forEach((element) => {
				if (element.id === undefined) {
					return;
				}
				elements.push(element);
			});
			if (this.$route.params.id !== undefined) {
				await ecAxios
					.connection()
					.delete(`${process.env.VUE_APP_API_ADM_EC + api.env.EC_PESSOAS_USUARIO + usuario}`, {
						data: elements,
					})

					.then((response) => {
						if (response.status === 200) {
							this.$store.dispatch('setDatabase', {
								selecionado: null,
								usuario: this.$route.params.id,
								checked: this.$store.getters.getDatabase.usuario,
							});
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: `${e}`,
							type: 'is-danger',
						});
					});
			}
		},
		showModal() {
			switch (this.currentroute) {
				case 'Editar':
					this.$store.dispatch('setModalPessoa', true);
					break;
				case 'Usuário - Detalhes':
					this.$store.dispatch('setModalPessoa', true);
					break;
				case 'Forma de Pagamento':
					this.$store.dispatch('setModalPagamento', true);
					break;
				default:
					break;
			}
		},
		setModalPagamento() {
			this.$store.dispatch('setModalPessoa', true);
		},
		setModalCondPagamento() {
			this.$store.dispatch('setModalCondPagamento', true);
		},
		goBack() {
			const currentRouter = this.$router.currentRoute.path;
			// eslint-disable-next-line no-underscore-dangle
			const startLocation = this.$router.history._startLocation;
			if (window.history.length > 1 && currentRouter !== startLocation) {
				this.$router.go(-1);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@keyframes rotating {
	from {
		-ms-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-ms-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
.config-icon {
	cursor: pointer;
	color: #2477ff;
	margin-left: 10px;
	-webkit-animation: rotating 2s linear infinite;
	-moz-animation: rotating 2s linear infinite;
	-ms-animation: rotating 2s linear infinite;
	-o-animation: rotating 2s linear infinite;
	animation: rotating 2s linear infinite;
}

.config-icon-return {
	cursor: pointer;
	margin-left: 10px;
	color: #2477ff;
}

.add-icon {
	color: #2477ff;
	margin-right: 10px;
	cursor: pointer;
}
.date-picker-analytics {
	display: flex;
}

.left-side {
	display: flex;
	align-self: center;
	align-items: flex-end;
}
.container-breadcrumb {
	display: flex;
	width: 100%;
	height: 50px;
	margin-top: 10px;
	margin-bottom: 10px;
	align-self: center;
	align-items: center;
	justify-content: space-between;
}
.title-breadcrumb {
	display: flex;
	justify-content: center;
	align-items: center;
}
.text-breadcrumb {
	margin-left: 10px;
	font-size: 16px;
	font-weight: bold;
	color: $breadcrumb-color;
}
</style>

